import * as React from "react";

const IconAdd = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    fill="none"
    {...props}
  >
    <g stroke={props.color || "#4F4FFF"} strokeLinecap="round" strokeLinejoin="round">
      <path strokeWidth={2} d="M8.5 3.5v10" />
      <path strokeWidth={1.5} d="M13.5 8.5h-10" />
    </g>
  </svg>
);
export default IconAdd;
